import { render } from "./PiTab.vue?vue&type=template&id=788a2790"
import script from "./PiTab.vue?vue&type=script&lang=js"
export * from "./PiTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__